import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppLink} from "shared/UI/UIKit/Link";
import {AppLogoIcon} from "shared/UI/UIKit/icons/Logo";
import {getHomeUrl} from "services/navigation";
import {GLOBAL_CONFIG} from "../../../../config/config";
import styles from "./Header.module.scss";

export const AppHeader = () => {
  return (
    <header className={styles.header}>
      <AppFlex className={styles.container} unit="30" direction="row"
               alignItems="center" justifyContent="space-between">
        <AppLink to={getHomeUrl()}>
          <AppFlex direction="row" unit="30" alignItems="center">
            {/*<img src={".images/logo.png"}/>*/}
            <AppLogoIcon/>
          </AppFlex>
        </AppLink>
        <AppText secondary size={18} className={styles.subject}>
          {`${GLOBAL_CONFIG.mainSettings.grade}  ${GLOBAL_CONFIG.mainSettings.subject}`}
        </AppText>
      </AppFlex>
    </header>
  );
};
